// Submits a hidden form as a top-level navigation so the browser follows any
// redirect response, unlike fetch/XHR which would resolve the redirect internally.
function postRedirect(url, params = {}) {
  if (!url) {
    return;
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.enctype = 'application/x-www-form-urlencoded';

  Object.entries(params).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  form.remove();
}

export default postRedirect;
